import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Zap, Brain, Moon, Bone, CheckCircle, Shield } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-0 pb-16 px-4 relative max-w-[800px] mx-auto text-center overflow-hidden" data-id="element-160">
      {/* Background Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[600px] bg-[#2D5A3D] opacity-[0.03] blur-[100px] -z-10 rounded-full" data-id="element-161"></div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-162">
        {/* Pre-headline */}
        <div className="mb-6" data-id="element-163">
          <span className="inline-block py-1 px-3 rounded-full bg-[#F0F4EC] border border-[#2D5A3D]/20 text-[#2D5A3D] text-xs font-bold uppercase tracking-widest" data-id="element-164">
            Para adultos de 50+
          </span>
          <p className="mt-4 text-[#C17817] font-bold text-sm uppercase tracking-wider" data-id="element-165">
            RECUPERAR TU VITALIDAD ES POSIBLE (Y NATURAL)
          </p>
        </div>

        {/* Headlines */}
        <h1 className="text-3xl md:text-5xl leading-[1.2] font-serif font-bold text-[#2C1810] mb-4 tracking-tight" data-id="element-166">
          "El Sistema de <span className="text-[#2D5A3D]" data-id="element-167">Sinergia Herbal</span>{' '}
          que los Laboratorios Farmacéuticos No Quieren que Conozcas"
        </h1>

        <h2 className="text-lg text-[#5C4A3A] leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-168">
          Transforma ingredientes comunes de tu cocina en protocolos de sanación
          de grado profesional.
        </h2>

        {/* Product Image */}
        <div className="my-8 mx-auto relative group max-w-[380px]" data-id="element-169">
          {/* Outer golden glow matching the mockup's botanical aesthetic */}
          <div className="absolute -inset-6 bg-gradient-to-b from-[#C17817]/30 via-[#2D5A3D]/20 to-[#C17817]/20 rounded-2xl blur-3xl opacity-60 group-hover:opacity-80 transition duration-1000" data-id="element-170"></div>
          {/* Inner amber shimmer */}
          <div className="absolute -inset-2 bg-gradient-to-r from-[#C17817]/20 via-transparent to-[#C17817]/20 rounded-xl blur-xl opacity-50" data-id="element-171"></div>
          <img src="https://cdn.magicpatterns.com/uploads/iNEUHineDxK33A6JFu6xy2/mockup.png" alt="La Medicina Natural - Recetas y Remedios Sencillos" className="relative w-full h-auto block rounded-xl shadow-[0_20px_60px_rgba(0,0,0,0.4),0_0_40px_rgba(193,120,23,0.2)] border border-[#C17817]/30 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-172" />
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto mb-8 text-left" data-id="element-173">
          <div className="bg-white p-4 rounded-xl border border-[#E8DFD0] shadow-sm flex items-center gap-3" data-id="element-174">
            <div className="bg-[#FEF2F2] p-2 rounded-full text-[#B91C1C]" data-id="element-175">
              <Zap className="w-5 h-5" data-id="element-176" />
            </div>
            <span className="font-bold text-[#2C1810] text-sm" data-id="element-177">
              Energía real desde la semana 1
            </span>
          </div>
          <div className="bg-white p-4 rounded-xl border border-[#E8DFD0] shadow-sm flex items-center gap-3" data-id="element-178">
            <div className="bg-[#EFF6FF] p-2 rounded-full text-[#1D4ED8]" data-id="element-179">
              <Brain className="w-5 h-5" data-id="element-180" />
            </div>
            <span className="font-bold text-[#2C1810] text-sm" data-id="element-181">
              Claridad mental sin estimulantes
            </span>
          </div>
          <div className="bg-white p-4 rounded-xl border border-[#E8DFD0] shadow-sm flex items-center gap-3" data-id="element-182">
            <div className="bg-[#F5F3FF] p-2 rounded-full text-[#7C3AED]" data-id="element-183">
              <Moon className="w-5 h-5" data-id="element-184" />
            </div>
            <span className="font-bold text-[#2C1810] text-sm" data-id="element-185">
              Sueño profundo y reparador
            </span>
          </div>
          <div className="bg-white p-4 rounded-xl border border-[#E8DFD0] shadow-sm flex items-center gap-3" data-id="element-186">
            <div className="bg-[#F0FDF4] p-2 rounded-full text-[#166534]" data-id="element-187">
              <Bone className="w-5 h-5" data-id="element-188" />
            </div>
            <span className="font-bold text-[#2C1810] text-sm" data-id="element-189">
              Articulaciones sin inflamación
            </span>
          </div>
        </div>

        {/* Proof Line */}
        <div className="flex items-center justify-center gap-2 text-xs font-medium text-[#5C4A3A] mb-8 uppercase tracking-wide" data-id="element-190">
          <CheckCircle className="w-4 h-4 text-[#2D5A3D]" data-id="element-191" />
          <span data-id="element-192">9 protocolos documentados</span>
          <span className="text-[#E8DFD0]" data-id="element-193">•</span>
          <span data-id="element-194">Ingredientes de tu cocina</span>
          <span className="text-[#E8DFD0]" data-id="element-195">•</span>
          <span data-id="element-196">Respaldo científico</span>
        </div>

        {/* CTA */}
        <a href="#comprar" className="block w-full bg-gradient-to-r from-[#2D5A3D] to-[#1B4332] text-[#FEFCF6] font-bold py-5 px-6 rounded-xl text-lg uppercase tracking-wide shadow-[0_10px_20px_rgba(45,90,61,0.3)] hover:shadow-[0_15px_30px_rgba(45,90,61,0.4)] transform hover:-translate-y-1 transition-all duration-300 mb-4 animate-pulse-green" data-id="element-197">
          🌿 QUIERO MIS 9 PROTOCOLOS POR $6.97 →
        </a>

        {/* Trust Micro-line */}
        <div className="flex items-center justify-center gap-2 text-xs text-[#5C4A3A] mb-12" data-id="element-198">
          <Shield className="w-3 h-3 text-[#2D5A3D]" data-id="element-199" />
          <span data-id="element-200">Garantía 7 días</span>
          <span className="text-[#E8DFD0] mx-1" data-id="element-201">|</span>
          <span data-id="element-202">Acceso inmediato</span>
          <span className="text-[#E8DFD0] mx-1" data-id="element-203">|</span>
          <span data-id="element-204">Sin riesgo</span>
        </div>

        <div className="flex justify-center" data-id="element-205">
          <ArrowDown className="w-6 h-6 text-[#2D5A3D] animate-bounce opacity-60" data-id="element-206" />
        </div>
      </motion.div>
    </section>;
}